import styled from "styled-components";
import React, { useState } from "react";
import { FormAnswer } from "../Form";
import theme from "../../../UI/theme";
import { ButtonRowContainer } from "../../panel/ModalStyles";
import Button from "../../UiComponents/Button";
import ProgressDots from "../ProgressDots";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;

    p {
        font-size: 1.2rem;
        color: ${theme.colors.textGray};
        text-align: center;
        font-weight: 600;
        margin-bottom: 0px;
    }
`

const StarsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
`

const Star = styled.div`
    font-size: 2rem;
    color: ${props => props.filled ? theme.colors.greenEnergy : theme.colors.textGray};
    cursor: pointer;
    padding: 10px;
    transition: color 0.15s ease;
`

const StarRating = ({form, questionDetails, nextQuestion, nextText, closable=true, close=() => {}, totalQuestions=null, currentQuestionNumber=null, isLastQuestion=false}) => {

    const [hoveredStar, setHoveredStar] = useState(0);
    const [selectedStar, setSelectedStar] = useState(null);
    const range = Array.from({length: questionDetails.answerMaxValue}, (_, i) => i + 1);


    const onHoverHandler = (starValue) => {
        if (!selectedStar) setHoveredStar(starValue);
    }

    const submitAnswer = async (starValue) => {
        if (!starValue) return nextQuestion();
        const answer = new FormAnswer(form, questionDetails.questionId, questionDetails.questionNumber, questionDetails.questionText, questionDetails.answerValueType, 5, 1);
        answer.setAnswerValue(starValue);
        await answer.save();
        nextQuestion(starValue);
    }

    const onCloseHandler = async () => {
        if (closable) {
            await submitAnswer();
            close();
        }
    }

    const activeStar = hoveredStar || selectedStar;

    return <Container>
        {(totalQuestions && currentQuestionNumber) && <ProgressDots total={totalQuestions} current={currentQuestionNumber} />}
        <h2>{questionDetails.questionText}</h2>
        {questionDetails.questionSubtext && <p>{questionDetails.questionSubtext}</p>}
        <StarsContainer>
            {range.map(starValue => {
                return (
                    <Star 
                        key={starValue}
                        filled={starValue <= activeStar}
                        onMouseEnter={() => onHoverHandler(starValue)}
                        onMouseLeave={() => onHoverHandler(selectedStar || 0)}
                        onClick={() => {
                            setHoveredStar(starValue);
                            setSelectedStar(starValue);
                        }}
                    >&#9733;</Star>
                )
            })}
        </StarsContainer>
        <ButtonRowContainer>
            <Button primary disabled={!selectedStar && !isLastQuestion} onClick={() => submitAnswer(selectedStar)} style={{marginTop: '20px'}}>{nextText || (isLastQuestion ? 'Submit' : 'Next')}</Button>
            {(closable && !isLastQuestion)&& <Button secondary onClick={onCloseHandler} style={{marginTop: '20px'}}>Close</Button>}
        </ButtonRowContainer>
    </Container>

}

export default StarRating;